export function createClasses(prefix, classes) {
	if (classes) {
		return classes.map(function (item) {
			return prefix + '--' + item;
		}).join(' ');
	} else {
		return '';
	}
}

export function slugify(string) {
	var a = 'àáäâãåăæçèéëêǵḧìíïîḿńǹñòóöôœṕŕßśșțùúüûǘẃẍÿź·/_,:;';
	var b = 'aaaaaaaaceeeeghiiiimnnnoooooprssstuuuuuwxyz------';
	var p = new RegExp(a.split('').join('|'), 'g');

	return string.toString().toLowerCase().replace(/\s+/g, '_') // Replace spaces with -
	.replace(p, function (c) {
		return b.charAt(a.indexOf(c));
	}) // Replace special characters
	.replace(/&/g, '-and-') // Replace & with 'and'
	.replace(/[^\w\-]+/g, '') // Remove all non-word characters
	.replace(/\-\-+/g, '_') // Replace multiple - with single -
	.replace(/^-+/, '') // Trim - from start of text
	.replace(/-+$/, ''); // Trim - from end of text
}

export function htmlDecode(input) {
	var e = document.createElement('textarea');
	e.innerHTML = input;
	// handle case of empty input
	return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
}